import fetch from 'unfetch';

export async function fetchJSON(url, method, payload) {
  const response = await fetch(url, {
    method: method,
    headers: {
      Accept: 'application/json',
    },
    body: payload,
    credentials: 'same-origin',
  });
  if (response.status > 400) {
    throw new Error();
  }
  const data = await response.json();
  if (response.status === 400 && (!data.errors || !data.errors.length)) {
    throw new Error();
  }
  if (data.errors) {
    const validationError = new Error();
    validationError.data = data.errors;
    throw validationError;
  }
}
